var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchPri(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5C1 15.7467 5.25329 20 10.5 20Z",
    stroke: "#205A46",
    style: (_ref2 = {
      stroke: "#205A46"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.1255 0.3529 0.2745)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.501 17.4998L21.001 20.9998",
    stroke: "#205A46",
    style: (_ref3 = {
      stroke: "#205A46"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.1255 0.3529 0.2745)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPri);
export default __webpack_public_path__ + "static/media/searchPri.4a04f164.svg";
export { ForwardRef as ReactComponent };